export default __webpack_public_path__ + "static/SCS_Verified_HealthProductDeclaration_1CG-7a2b263a704f34e51947af7d1dac0adf.png";